import { computed } from '@vue/composition-api'
import { useCurrentData } from '@/composables/useCurrentData'
import i18n from '@/i18n'

export function useComment() {
    const { currentUser, currentCompany } = useCurrentData()

    const commentVisibilityOptions = computed(() => {
        return ['personal', 'private', 'public'].map(visibility => ({
            value: visibility,
            label: i18n.t(`comment.visibility.${visibility}`, {
                userName: currentUser.value?.name || '',
                companyName: currentCompany.value?.name || '',
            }),
        }))
    })

    return {
        commentVisibilityOptions,
    }
}
